import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Asegúrate de mantener tus imports completos
import { loginUser } from '../../services/AuthService';

import '../static/Login.css';
import '../static/Global.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // Estructura para el ojito
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // EFECTO: Si ya está logueado, mandarlo directo al Dashboard
  useEffect(() => {
    if (sessionStorage.getItem('isAuthenticated') === 'true') {
      navigate('/DashboardUsuarios');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const data = await loginUser(email, password);

      if (data.success) {
        if (data.usuario.rol === 'ADMINISTRADOR' || data.usuario.rol === 'EMPLEADO') {
          
          sessionStorage.setItem('isAuthenticated', 'true');
          sessionStorage.setItem('userRole', data.usuario.rol);
          sessionStorage.setItem('usuario_novatech', JSON.stringify({
            id: data.usuario.id,
            email: data.usuario.email,
            rol: data.usuario.rol,
            nombre: data.usuario.nombre
          }));

          navigate('/DashboardUsuarios');

        } else {
          setError("Acceso restringido para este rol.");
        }
      } else {
        setError(data.error || "Credenciales incorrectas");
      }

    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    }
  };

  // Función para alternar el estado del ojito
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="Login">
      <main className="main__auth__hero">
        <section className="content_forms">
          <form className="form" onSubmit={handleSubmit}>
            <div className="form__bg"></div>
            <div className="form__content">
              <header className="form__header">
                <h2>INICIAR SESIÓN</h2>
                <p>Por favor ingresar su correo y contraseña</p>
              </header>

              {/* ALERTA DE ERROR DINÁMICA */}
              {error && (
                <div className="alert alert-danger p-2 animate__animated animate__shakeX" 
                     style={{ fontSize: '0.85rem', borderLeft: '4px solid #721c24' }}>
                  <i className="fa-solid fa-triangle-exclamation me-2"></i>
                  {error}
                </div>
              )}

              <section className="form__content">
                <div className="form__content__inputs">
                  <input
                    type="email"
                    name="email"
                    placeholder="Correo Electrónico"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  
                  {/* CONTENEDOR NUEVO PARA EL INPUT DE CONTRASEÑA Y EL OJITO */}
                  <div className="password-container" style={{ position: 'relative', width: '100%' }}>
                    <input
                      type={showPassword ? "text" : "password"} // Cambia dinámicamente
                      name="password"
                      placeholder="Contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      style={{ width: '100%', paddingRight: '40px' }} // Espacio para que el texto no tape el ojo
                    />
                    <span 
                      onClick={togglePasswordVisibility} 
                      style={{
                        position: 'absolute',
                        right: '15px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: '#666',
                        zIndex: 10
                      }}
                    >
                      {/* Intercambia el icono de FontAwesome según el estado */}
                      <i className={showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}></i>
                    </span>
                  </div>
                </div>

                <div className="form__content__actions">
                  <button className="btn-filled" type="submit">
                    INICIAR SESIÓN
                  </button>
                </div>
              </section>
            </div>
          </form>
        </section>
      </main>
    </div>
  );
}

export default Login;